export default __webpack_public_path__ + "static/media/plus.a2530e7d.svg";